import styled from 'styled-components';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.div`
  position: relative;
  margin: 40px 0 10px;

  .where-to-watch,
  &.where-to-watch {
    &__live-title {
      font-size: 1.4rem;
      line-height: 1.4rem;
      font-weight: 600;
      margin-bottom: 15px;
    }

    &__title {
      position: relative;
      display: flex;
      align-items: center;
      margin-bottom: -26px;
      z-index: 2;

      ${breakpoints.up('sm')} {
        width: calc(100% - 70px);
      }
    }

    &__seasons-title {
      font-weight: 500;
      margin-left: 16px;
    }

    .notify-me,
    &__notify-me {
      width: 100%;
      margin-top: 35px;

      .MuiAlert-message {
        width: 100%;
      }

      &__form {
        &-input {
          input {
            &:not(:disabled) {
              background-color: ${p => p.theme.palette.common.white};
            }
          }
        }
        &-button {
          margin-top: 4px;
        }
      }
    }
  }
`;

export default Container;
